import { useEffect } from 'react';
// Removed Link import as it's not used directly here anymore

const CookiePolicy = () => {
  useEffect(() => {
    window.scrollTo(0, 0); // Scroll to top when component mounts
  }, []);

  return (
    // Match container and padding from Integritetspolicy
    <div className="container mx-auto px-4 py-12 max-w-3xl"> 
      {/* Match h1 style */}
      <h1 className="text-3xl font-bold mb-8 text-minnestig-teal">Cookiepolicy</h1>

      {/* Section 1 */}
      <section className="mb-8">
        {/* Match h2 style */}
        <h2 className="text-2xl font-semibold mb-4 text-minnestig-darkpurple">1. Vad är cookies?</h2>
        {/* Match p style */}
        <p className="text-gray-700 leading-relaxed">
          Cookies är små textfiler som lagras på din enhet när du besöker en webbplats. De hjälper
          oss att förstå hur sidan används och kan förbättra din upplevelse. Vissa cookies är
          nödvändiga för att webbplatsen ska fungera, andra används för analys eller
          tredjepartstjänster.
        </p>
      </section>

      {/* Section 2 */}
      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-4 text-minnestig-darkpurple">2. Vilka cookies använder vi?</h2>
        <p className="text-gray-700 leading-relaxed mb-4">Vi använder följande typer av cookies:</p>
        {/* Using h3 for subheadings, style similarly to h2 but smaller? Or just bold p? Let's use bold p for now */}
        <p className="text-gray-700 leading-relaxed font-semibold mt-4">Nödvändiga cookies</p>
        <p className="text-gray-700 leading-relaxed">
          Dessa krävs för att webbplatsen ska fungera korrekt (exempelvis för att formulär ska
          skickas). Dessa kan inte stängas av via vår cookie-banner då de är fundamentala för sidans funktion.
        </p>
        <p className="text-gray-700 leading-relaxed font-semibold mt-4">Analytiska cookies</p>
        <p className="text-gray-700 leading-relaxed">
          Vi använder Google Analytics för att förstå hur besökare hittar och använder vår webbplats.
          Detta hjälper oss förbättra innehållet.
        </p>
        <p className="text-gray-700 leading-relaxed">👉 Dessa används endast med ditt samtycke.</p>
      </section>

      {/* Section 3 */}
      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-4 text-minnestig-darkpurple">3. Samtycke</h2>
        <p className="text-gray-700 leading-relaxed mb-4">
          När du besöker vår webbplats för första gången visas en cookie-banner som låter dig välja:
        </p>
        {/* Match ul style */}
        <ul className="list-disc list-inside text-gray-700 leading-relaxed space-y-2 mb-4">
          <li>Acceptera alla cookies</li>
          <li>Endast nödvändiga cookies</li>
        </ul>
        <p className="text-gray-700 leading-relaxed">
          Du kan när som helst ändra ditt val genom att rensa cookies för denna webbplats i din webbläsare, vilket gör att bannern visas igen vid nästa besök.
        </p>
      </section>

      {/* Section 4 */}
      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-4 text-minnestig-darkpurple">4. Hur länge sparas cookies?</h2>
        <ul className="list-disc list-inside text-gray-700 leading-relaxed space-y-2 mb-4">
          <li>Sessionscookies försvinner när du stänger webbläsaren.</li>
          <li>Analytiska cookies (Google Analytics) kan sparas i upp till 12 månader om du samtycker till dem.</li>
          <li>Du kan rensa cookies via din webbläsares inställningar när som helst.</li>
        </ul>
      </section>

      {/* Section 5 */}
      <section className="mb-8">
        <h2 className="text-2xl font-semibold mb-4 text-minnestig-darkpurple">5. Så hanterar du cookies</h2>
        <p className="text-gray-700 leading-relaxed">
          Du kan blockera eller radera cookies genom att justera inställningarna i din webbläsare.
          Notera dock att vissa delar av webbplatsen kan sluta fungera om du blockerar nödvändiga
          cookies.
        </p>
      </section>

      {/* Section 6 */}
      <section> {/* Removed mb-8 from last section */}
        <h2 className="text-2xl font-semibold mb-4 text-minnestig-darkpurple">6. Kontakt</h2>
        <p className="text-gray-700 leading-relaxed">
          Har du frågor om vår cookiepolicy eller hur vi använder data? Kontakta oss på:
          <br />
          {/* Match link style */}
          <a href="mailto:hej@demenshjaltar.se" className="text-minnestig-purple hover:underline">hej@demenshjaltar.se</a>
        </p>
      </section>
    </div>
  );
};

export default CookiePolicy;
